// extracted by mini-css-extract-plugin
export var authorContainer = "QuoteModule-module--authorContainer--5aef8";
export var authorInfo = "QuoteModule-module--authorInfo--9ecfd";
export var authorName = "QuoteModule-module--authorName--4cb5b";
export var authorPosition = "QuoteModule-module--authorPosition--124d1";
export var contentContainer = "QuoteModule-module--contentContainer--4268b";
export var desktop = "QuoteModule-module--desktop--09605";
export var divider = "QuoteModule-module--divider--8e6fa";
export var mobile = "QuoteModule-module--mobile--c1cc7";
export var quote = "QuoteModule-module--quote--226dc";